var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-24p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8650_164958",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8650_164958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "receipt_long",
    d: "M6.2597 21C5.62815 21 5.09364 20.7813 4.65618 20.3438C4.21873 19.9064 4 19.3732 4 18.7444V16.4806H6.71167V4L7.96321 5.07771L9.23211 4L10.501 5.07771L11.7699 4L13.0389 5.07771L14.3078 4L15.5767 5.07771L16.8456 4L18.1145 5.07771L19.3661 4V18.7403C19.3661 19.3718 19.1473 19.9064 18.7099 20.3438C18.2724 20.7813 17.7379 21 17.1064 21H6.2597ZM17.1064 19.6442C17.3625 19.6442 17.5771 19.5576 17.7504 19.3843C17.9236 19.2111 18.0103 18.9964 18.0103 18.7403V6.08586H8.06748V16.4806H16.2025V18.7403C16.2025 18.9964 16.2891 19.2111 16.4623 19.3843C16.6356 19.5576 16.8503 19.6442 17.1064 19.6442ZM9.14521 9.47542V8.11963H14.273V9.47542H9.14521ZM9.14521 12.1871V10.8313H14.273V12.1871H9.14521ZM16.1503 9.5971C15.929 9.5971 15.7404 9.51918 15.5845 9.36332C15.4287 9.20745 15.3507 9.01886 15.3507 8.79753C15.3507 8.57619 15.4287 8.3876 15.5845 8.23174C15.7404 8.07588 15.929 7.99795 16.1503 7.99795C16.3717 7.99795 16.5603 8.07588 16.7161 8.23174C16.872 8.3876 16.9499 8.57619 16.9499 8.79753C16.9499 9.01886 16.872 9.20745 16.7161 9.36332C16.5603 9.51918 16.3717 9.5971 16.1503 9.5971ZM16.1503 12.3088C15.929 12.3088 15.7404 12.2308 15.5845 12.075C15.4287 11.9191 15.3507 11.7305 15.3507 11.5092C15.3507 11.2879 15.4287 11.0993 15.5845 10.9434C15.7404 10.7875 15.929 10.7096 16.1503 10.7096C16.3717 10.7096 16.5603 10.7875 16.7161 10.9434C16.872 11.0993 16.9499 11.2879 16.9499 11.5092C16.9499 11.7305 16.872 11.9191 16.7161 12.075C16.5603 12.2308 16.3717 12.3088 16.1503 12.3088ZM6.2597 19.6442H14.8467V17.8364H5.35581V18.7403C5.35581 18.9964 5.44243 19.2111 5.61568 19.3843C5.78892 19.5576 6.0036 19.6442 6.2597 19.6442Z",
    fill: "#A5ACB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptLong);
export default __webpack_public_path__ + "static/media/receipt_long.eaa6f330e5cd09b1e6a8f0d32bfd40f6.svg";
export { ForwardRef as ReactComponent };